<template>
    <div>
        <v-bottom-sheet v-model="order_screen">
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs" 
                    v-on="on" 
                    color="black"
                    outlined
                    :block="$vuetify.breakpoint.smAndDown"
                    :small="$vuetify.breakpoint.mdAndDown"
                    :class="$vuetify.breakpoint.mdAndDown ? 'caption' : $css_button "
                >
                    <v-icon left>
                        mdi-wifi-arrow-up-down
                    </v-icon>
                    <span style="font-size: 12px">{{ object.current_order.description }} - {{ object.current_order.sense_description }}</span>
                </v-btn>    

            </template>
            <v-list class="pa-4">
                <v-form ref="form">
                <v-subheader>Ordem</v-subheader>

                <v-radio-group v-model="radioGroup">
                    <v-radio
                        v-for="n in object.items"
                        :key="n.value"
                        :label="`${n.description}`"
                        :value="n.value"
                    ></v-radio>
                </v-radio-group>

                <v-row dense>
                    <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <v-select
                            v-model="sense"
                            :items="items.sense"
                            :rules="[rules.required]"
                            item-text="description"
                            item-value="value"
                            outlined
                            dense
                            :class="$vuetify.breakpoint.mdAndDown ? 'caption' : $css_button "
                        >
                            <template v-slot:label>
                                <span :class="$css_field">Sentido</span>
                            </template>
                        </v-select>
                    </v-col>    
                </v-row>
                <v-row dense>
                    <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <v-btn
                            dark
                            color="primary"
                            @click="validate()"
                            :class="$css_button"
                        >
                            Ordenar Lista
                        </v-btn>
                    </v-col>    
                </v-row>
                </v-form>
            </v-list>
        </v-bottom-sheet>
    </div>
</template>

<script>
export default {
    props: {
        object: {
            handler:function() {
                console.log('entrou')
            },
            deep:true
        },
    }, 

    mounted() {
        
    },

    data () {
        return {
            order_screen: false,
            radioGroup: this.object.current_order.value,
            sense: this.object.current_order.sense,
            items: {
                sense: this.object.sense
            },
            rules: {
                required: value => !!value || 'Obrigatório',
            },
        }    
    },

    methods: {
        validate () {
            if (this.$refs.form.validate()) {
                this.setOrder()
            }
        },

        setOrder(){     
            const params = {}
            params.order = this.radioGroup
            params.sense = this.sense
            this.$emit('callLoadItems',params)
            this.order_screen = false
        },
    },
}
</script>

